<template>
    <div class="container">
        <van-nav-bar leftText class="cart-header headerbar" title="提交结果"></van-nav-bar>
        <div class="topbar-container">
            <div class="scrollbar-container">
                <div class="content bv bc">
                    <div class="winIco bg-contain"></div>
                    <div class="title fz_34 c_333">提交成功</div>
                    <div class="text fz_24 c_999">
                        请等待管理员审核，
                        <span class="time">{{num}}s</span>后自动跳转页面
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { routeCache } from "@/mixin/cache";
import { user } from "@/mixin/user";
export default {
    mixins: [routeCache, user],
    data() {
        return {
            num: 3
        };
    },
    methods: {
        userLoginend() {
            const params = this.getCache();
            const timer = setInterval(() => {
                if (this.num == 0) {
                    clearInterval(timer);
                    this.replaceGo("ScooterOrderInfo", params);
                }
                this.num > 0 ? this.num-- : (this.num = 0);
            }, 1000);
        }
    }
};
</script>
<style scoped lang="scss">
.container {
    background-color: #f6f6f6;
}
.scrollbar-container {
    .content {
        padding: 230px 0;
        .winIco {
            height: 238px;
            width: 284px;
            background-image: url("~@/assets/imges/scooter/wait.png");
        }
        .title {
            padding: 40px 0;
        }
        .time {
            color: #c30d23;
        }
    }
}
</style>
